import { action, computed, observable, reaction, makeObservable } from 'mobx';
import { Disposers, HttpPromiseState, logger } from 'lib/helpers';
import { EssaysStatus, ExamStudentListResponse, EssayListDto } from '../ExamModels';
import { ExamLoaders } from '../ExamLoaders';
import {Control, StringControl, validators} from '../../../lib/helpers';

export class ExamTeacherListSceneStore {
    @observable
    currentPage: number = 0;
    status: Control<EssaysStatus[]>;
    filterDate: string | null
    
    @observable.ref
    loader: HttpPromiseState<ExamStudentListResponse> | null;

    private readonly disposers = new Disposers();

    constructor() {
        makeObservable(this);
        this.loader = null;
        this.currentPage = 0;
        this.status = new Control<EssaysStatus[]>('', []);
        this.setup();
        this.filterDate = null;
    }

    private setup() {
        this.disposers.add(
            reaction(
                () => this.loader?.value,
                this.onLoaded),
        );
    }
    @action
    resetResults = () => {
        window.location.reload();
    };

    @action
    load = () => {
        if (this.loader?.isPending)
            return;

        const request: EssayListDto = {
            Filter:this.state,
            Page: this.currentPage,
            FilterDate: this.filterDate
        };
        this.loader = ExamLoaders.teacherGetList(request);
    };

    @action
    loadNextPage = () => {
    
        this.currentPage++;
        this.load();
    };

    @action
    loadPreviousPage = () => {
    
        this.currentPage--;
        this.load();
    };

    @action
    getDay = () => {
        this.filterDate = "Day"
        this.load();
    };

    @action
    getMonth = () => {
        this.filterDate = "Month"
        this.load();
    };
    @action
    getWeek = () => {
        this.filterDate = "Week"
        this.load();
    };
    @action
    getYear = () => {
        this.filterDate = "Year"
        this.load();
    };

    @computed
    get state(): string[] {
        return this.status.value
    }
    @action
    private onLoaded = () => {
        const state = this.loader;
        if (state === null || !state.isResolved)
            return;
    };

    dispose() {
        this.disposers.dispose();
    }
}
